export enum SubscriptionStatus {
  Active = "Active",
  Inactive = "Inactive",
  Pending = "Pending",
  PastDue = "Past Due",
  Cancelled = "Cancelled",
  Paused = "Paused",
  Completed = "Completed",
}
export enum CancelSubscriptionTypes {
  Immediately = "Immediately",
  EndOfCurrentBillingPeriod = "EndOfCurrentBillingPeriod",
  OnCustomDate = "OnCustomDate",
}

export enum RefundSubscriptionTypes {
  None = "None",
  PaymentTransaction = "PaymentTransaction",
  CustomAmount = "CustomAmount",
}

export enum PauseDurationTypes {
  UntilManuallyResumed = "UntilManuallyResumed",
  ResumeOnDate = "ResumeOnDate",
}

export enum PauseSubscriptionOutStandingInvoiceActions {
  PastDue = "PastDue",
  MarkUncollectible = "MarkUncollectible",
  MarkCancelled = "MarkCancelled",
  None = "None",
}
